import { format, parseISO } from 'date-fns';
import * as React from 'react';
import { Icon } from '../Icon/Icon';
import { capitalizeFirstLetter } from '../Util';
import sv from '../Util/customDateFnsSwedish';
import formatCloseRelative from '../Util/formatCloseRelative';
import type { SearchResult } from './Types';

export interface ISearchListProps {
    items: SearchResult[];
}

export class SearchList extends React.Component<ISearchListProps> {
    constructor(props: ISearchListProps) {
        super(props);
    }

    render(): JSX.Element {
        return (
            <>
                {this.props.items.length === 0 && (
                    <div className="no-result mt-0 mt-md-1">
                        <p className="mb-0">Det finns inga resultat att visa</p>
                    </div>
                )}
                {this.props.items.length > 0 && <div className="search-info__search-list">{this.props.items.map(this.renderItem.bind(this))}</div>}
            </>
        );
    }

    private getStatusTextFromIcon(iconId: string) {
        switch (iconId) {
            case 'ta-plan-current':
                return 'Gällande';
            case 'ta-plan-coming':
                return 'Kommande';
            case 'ta-plan-completed':
                return 'Avslutad';
            default:
                return '';
        }
    }

    private renderItem(item: SearchResult, index: number): JSX.Element {
        return (
            <div key={index}>
                <hr />
                <a href={item.url}>
                    <div className="search-info__list-item">
                        {item.iconId !== undefined && item.iconId !== null && item.iconId.length > 0 ? (
                            <div className="search-info__list-item-icon">
                                <Icon symbol={item.iconId} />
                            </div>
                        ) : (
                            <div className="search-info__list-item-icon" />
                        )}
                        <div className="search-info__list-item-content">
                            {item.typeName === 'TAPlanSearchModel' ? (
                                <div
                                    className="search-info__item-content-type"
                                    dangerouslySetInnerHTML={{ __html: this.getStatusTextFromIcon(item.iconId) + ' ' + item.displayName }}
                                />
                            ) : (
                                <div className="search-info__item-content-type" dangerouslySetInnerHTML={{ __html: item.displayName }} />
                            )}
                            <div className="search-info__item-content-title" dangerouslySetInnerHTML={{ __html: item.title }} />
                            {item.excerpt !== undefined && item.excerpt !== null && item.excerpt.length > 0 ? (
                                <div className="search-info__item-content-description" dangerouslySetInnerHTML={{ __html: item.excerpt }} />
                            ) : null}
                            {item.typeName === 'SituationSearchModel' ? (
                                <>
                                    {item.startTime ? (
                                        <div className="search__item-content-date">
                                            <span className="icon-clock" />
                                            Giltigt från: {capitalizeFirstLetter(formatCloseRelative(parseISO(item.startTime)))}
                                            {'. '}
                                            {item.endTime
                                                ? 'Beräknas pågå till: ' + capitalizeFirstLetter(formatCloseRelative(parseISO(item.endTime)))
                                                : 'Gäller tills vidare'}
                                        </div>
                                    ) : null}
                                </>
                            ) : null}
                            {item.typeName === 'TAPlanSearchModel' ? (
                                <>
                                    {item.startTime ? (
                                        <div className="search__item-content-date">
                                            <span className="icon-clock" />
                                            Tillstånd gäller från: {format(parseISO(item.startTime), 'P', { locale: sv })}
                                            {'. '}
                                            {item.endTime
                                                ? 'Gäller till: ' + format(parseISO(item.endTime), 'P', { locale: sv })
                                                : 'Gäller tills vidare'}
                                        </div>
                                    ) : null}
                                </>
                            ) : null}

                            {item.typeName === 'NewsArticlePage' ? (
                                <div className="search__item-content-date">
                                    <span className="icon-clock" />
                                    Publicerad: {capitalizeFirstLetter(formatCloseRelative(parseISO(item.publishDate)))}
                                </div>
                            ) : null}
                        </div>
                    </div>
                </a>
            </div>
        );
    }
}
